import Loading from "../../../components/loading";
import useCreateRuleset, {
  CreateRuleSetState,
} from "./hooks/use-create-ruleset";
import CreateRuleSetActions from "./components/create-ruleset-actions";
import CreateRuleSetRules from "./components/create-ruleset-rules";
import CreateRuleSetForm from "./components/create-ruleset-form";
import Header from "../../../components/header";
import ErrorDisplay from "../../../components/error-display";
import Saving from "../../../components/saving";
import SaveComplete from "../../../components/save-complete";

export default function CreateRuleSet() {
  const createRulesetState: CreateRuleSetState = useCreateRuleset();

  return (
    <div className='min-h-[1024px] h-full'>
      {createRulesetState.saving && (
        <div className="absolute inset-0 flex flex-col h-full">
          <Saving />
        </div>
      )}
      {createRulesetState.saveComplete && (
        <div className="absolute inset-0 flex flex-col h-full">
          <SaveComplete />
        </div>
      )}
      <div className="flex-grow">
        <form
          className="absolute inset-0 top-0 bottom-36 h-full min-h-[1024px]"
          onSubmit={createRulesetState.handleSubmit(
            createRulesetState.doSubmit
          )}
        >
          <Header>
            <div className="py-6 text-3xl font-semibold text-white">
              Create New Rule Set
            </div>
          </Header>
          <div className="absolute inset-0 overflow-y-hidden top-56 bottom-8">
            {createRulesetState.errorMessage && (
              <ErrorDisplay
                message={createRulesetState.errorMessage}
                onClick={createRulesetState.clearError}
              />
            )}
            {createRulesetState.loading && (
              <div className="absolute inset-0 flex items-center justify-center">
                <Loading />
              </div>
            )}
            {!createRulesetState.saveComplete &&
              !createRulesetState.loading &&
              createRulesetState.ruleset && (
                <div className="flex-grow">
                  <CreateRuleSetForm state={createRulesetState} />
                  <CreateRuleSetRules state={createRulesetState} />
                </div>
              )}
          </div>
          <div className="absolute left-0 right-0 z-10 flex items-center bg-white shadow-lg -bottom-36 h-36">
            <CreateRuleSetActions state={createRulesetState} />
          </div>
        </form>
      </div>
    </div>
  );
}
